import axios from "axios"

function useToggleShortlisted() {

  const handleShortListTrend = async (trendId, todelete = false) => {
    try {
      const body = { trendId: trendId }
      if (todelete) {
        body.delete = true;
      }
      const response = await axios.post(`/api/saved-images/shortlisted-trend`, body)
      if (response.data.success) {
        return true
      }
    } catch (e) {
      console.error(e)
    }

  }

  return handleShortListTrend
}

export default useToggleShortlisted;
